const API_BASE_URL = "https://rmpapi.iworkx.in"; // ✅ Correct port

const api = {
  /* -------------------- Core Helpers -------------------- */
  get: async (endpoint, params = {}) => {
    const url = new URL(`${API_BASE_URL}/${endpoint}`);
    const dbKey = sessionStorage.getItem("databaseKey");
    if (dbKey && !params.databaseKey) {
      params.databaseKey = dbKey;
    }

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    const response = await fetch(url);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP GET error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  post: async (endpoint, body = {}) => {
    const dbKey = sessionStorage.getItem("databaseKey");
    const url = new URL(`${API_BASE_URL}/${endpoint}`);
    if (dbKey) {
      url.searchParams.append("databaseKey", dbKey);
    }

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`HTTP POST error! status: ${response.status}, body: ${text}`);
    }
    return await response.json();
  },

  /* -------------------- Existing APIs -------------------- */
  // checkLogin: (userName, userpwd) =>
  //   api.get("CheckLogin", { UserName: userName, Userpwd: userpwd }),

checkLogin: (userName, userpwd) =>
  api.post("CheckLogin", { UserName: userName, Userpwd: userpwd }),

  getShiftDetails: (username) =>
    api.get("GetShiftDetails", { username }),

  getAttendanceList: (docDate, shiftId) =>
    api.get("GetAttendanceList", { docDate, shiftId }),

  checkVendorMapping: (payload) =>
    api.post("CheckVendorMapping", payload),

  /* -------------------- New APIs -------------------- */
  getSubcontractorMatchStatus: (excelData, matchStatus) =>
    api.post("GetSubcontractorMatchStatus", { excelData, matchStatus }),

  getEmpTypeMatchStatus: (excelData, matchStatus) =>
    api.post("GetEmpTypeMatchStatus", { excelData, matchStatus }),

  getScnameEmptypeStatus: ({ atDate, shiftName, type }) =>
    api.get("GetScnameEmptypeStatus", { atDate, shiftName, type }),

getRefreshAttendance: (atDate, shiftName) =>
  api.get("GetRefreshAttendance", { atDate, shiftName }),

  updateEmpTypeAttendance: (updates) =>
    api.post("UpdateEmpTypeAttendance", updates ),

  updateSubcontractorAttendance: (updates) =>
    api.post("UpdateSubcontractorAttendance", updates),

    UpdateDepartmentAttendance: (updates) =>
    api.post("UpdateDepartmentAttendance", updates),

  insertOnlineAttendance: (payload) =>
    api.post("InsertOnlineAttendance", payload),
};

export default api;
